import { doc, updateDoc, getFirestore } from 'firebase/firestore';
import { collectionName } from './constants';

const updateCategory = (categoryId: string, values: any) => {
  updateDoc(doc(getFirestore(), collectionName, categoryId), values);
};

export default updateCategory;
